import ModelState from './_util/model';

/*
 * The /me/home route for rebook suggestions etc
 * http://api.staging.urban.co/docs/#api-me-api
 */
class HomeState extends ModelState {
  get url() { return '/me/home'; }
  get singular() { return 'suggestion'; }
  get plural() { return 'suggestions'; }
  get iteratorMap() { return {suggestions: 'orders'}; }
}

export default HomeState;



// WEBPACK FOOTER //
// ./spa/state/home.jsx